import { CompleteUmbrueckungDialogComponent } from './../component/complete-umbrueckung-dialog.component';
import { UmbrueckungDetails } from './../model/umbrueckung-details';
import { BeginUmbrueckungDialogComponent } from '../component/begin-umbrueckung-dialog.component';
import { DialogService, AppServerAPI } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AsyncSubject } from 'rxjs';
import { ResponseStatus } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { TransportStationAssignment } from '../model/transport-station-assignment';


@Injectable({
  providedIn: 'root'
})
export class TransportUmbrueckungService {

  constructor(
    private appServerAPI: AppServerAPI,
    private dialogService: DialogService,
    private dialog: MatDialog) { }


  public completeTransportUmbrueckung(details: UmbrueckungDetails): AsyncSubject<void> {

    const result = new AsyncSubject<void>();

    const dialogRef = this.dialog.open(CompleteUmbrueckungDialogComponent, {
      maxHeight: '95vh',
      data: {
        details
      },
      panelClass: 'tmc-dialog-container',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(
      r => {
        result.next();
        result.complete();
      }
    );

    return result;
  }

  public beginTransportUmbrueckung(assignment: TransportStationAssignment): AsyncSubject<void> {

    const result = new AsyncSubject<void>();

    this.appServerAPI.execute<ServiceResponse>('/client/control/umbrueckung', assignment).subscribe(
      details => {
        if (details.status !== ResponseStatus.SUCCESS) {

          const additionalMessageDictionaryKeys = new Array<string>();
          for (const message of details.responseMessages) {
            additionalMessageDictionaryKeys.push(message.dictionaryKey);
          }

          const ref = this.dialogService.showInfoDialog(
            'tmc-yard.ui.transport-umbrueckung.message-dialog-invalid-transport-title',
            'tmc-yard.ui.transport-umbrueckung.message-dialog-invalid-transport-message',
            additionalMessageDictionaryKeys
          );
          ref.afterClosed().subscribe(
            r => {
              result.next();
              result.complete();
            }
          );

        } else {
          const dialogRef = this.dialog.open(BeginUmbrueckungDialogComponent, {
            data: {
              details
            },
            panelClass: 'tmc-dialog-container',
            autoFocus: false
          });
          dialogRef.afterClosed().subscribe(
            r => {
              result.next();
              result.complete();
            }
          );
        }
      },
      error => {
        result.error('Error loading target transports');
        result.next();
        result.complete();
      }
    );

    return result;
  }
}

